import { createStore } from '~/store/createStore';
export const useThemeStore = createStore((set, get) => {
    return {
        theme: 'light',
    };
});
